<template>
  <div>
    <buttonlist ref="SetBtn" @help="help" @reflash="reflash" @save="save" ></buttonlist>
    <ul class="Boxs" ref="Box" :style="{ height: tableHeight - 90 + 'px' }">
      <li class="left" ref="left" style="width: 15%">
        <!--<el-table :data="dataNode"
                  :height="tableHeight - 90"
                  header-row-class-name="headerclass"
                  :show-header="false"
                  border size="mini"
                  style="width: 100%; margin-top:0px"
                  :header-cell-style="$limits.headerClass"
                  @row-click="getDetail"
                  :highlight-current-row="true"
        >

          <el-table-column show-overflow-tooltip prop="node_name" label="节点名称"></el-table-column>
        </el-table>-->

        <el-tree :highlight-current="true" lazy ref="tree" :data="dataTree" :props="defaultProps" node-key="node_id" :load="loadNode" :default-expanded-keys="defaultEexpandedkeys"
                 @node-click="getDetail"></el-tree>
      </li>

      <li class="resize" ref="resize">
        <i class="el-icon-caret-right" @click="leftt(0)"></i>
        <i class="el-icon-caret-left" @click="leftt(1)"></i>
      </li>

      <li class="mid" ref="mid" style="width: 85%; margin-left: 3px">
        <div class="btnnowrap">
          <el-button type="primary" size="mini" @click="showUsers" :disabled="nodeid == ''">{{$t('getapi[4412]')}}</el-button>
          <el-button type="primary" size="mini" @click="batchDel" :disabled="selectData.length != 1">{{$t('getapi[4411]')}}</el-button>
        </div>
        <!--<el-table
                id="xpane-0"
                ref="tree"
                :data="dataSet"
                v-loading="loading"
                :highlight-current-row="true"
                show-overflow-tooltip="true"
                border
                stripe
                size="mini"
                :height="tableHeight - 120"
                header-row-class-name="headerclass"
                style="width: 100%; margin-top:0px"
                :header-cell-style="$limits.headerClass"
                @selection-change="handleSelectionChange"
                :row-class-name="tableRowClassName"
        >
          <el-table-column type="selection"></el-table-column>
          <el-table-column show-overflow-tooltip prop="sort" width="50" align="center"></el-table-column>
          <el-table-column show-overflow-tooltip prop="department" :label="$t('getapi[3151]')" width="80"></el-table-column>
          <el-table-column show-overflow-tooltip prop="post" :label="$t('getapi[3228]')" width="150"></el-table-column>
          <el-table-column show-overflow-tooltip prop="login_code" :label="$t('getapi[3255]')" width="80"></el-table-column>
          <el-table-column show-overflow-tooltip prop="login_name" :label="$t('getapi[3202]')" width="80"></el-table-column>
        </el-table>-->
        <vxe-table
                border
                row-key
                ref="xTable1"
                @checkbox-change="handleSelectionChange"
                :row-class-name="tableRowClassName"
                class="sortable-row-demo"
                :scroll-y="{ enabled: false }"
                :data="dataSet"
                :height="tableHeight - 120"
                :checkbox-config="{ checkField: 'checked', trigger: 'row' ,reserve: false }"
                size="mini"
                resizable
                :keyboard-config="{ isArrow: true}"
        >
          <vxe-table-column type="checkbox" align="center" width="50"></vxe-table-column>
          <vxe-table-column field="sort" width="50"></vxe-table-column>
          <vxe-table-column field="department"  :title="$t('getapi[3151]')" width="80"></vxe-table-column>
          <vxe-table-column field="post"  :title="$t('getapi[3228]')" width="150"></vxe-table-column>
          <vxe-table-column field="login_code"  :title="$t('getapi[3255]')" width="80"></vxe-table-column>
          <vxe-table-column field="login_name"  :title="$t('getapi[3202]')" width="80"></vxe-table-column>
        </vxe-table>
      </li>
    </ul>
    <!--用户-->
    <selector :isVisible="false" :isBatch=true :selectType="0" :isSplitPage=true
              :postUrl="'/webdoc/doc/GetUserLoginInfoPopuView'" @callback="getUsers" ref="user"></selector>
  </div>

</template>
<script>
  import Sortable from 'sortablejs';
  import Common from "@/components/Common";
  import Array from "@/components/Array";
  import CommonHeader from "@/components/CommonHeader";
  export default {
    name: "docnodeapproval",
    data() {
      let curheight = window.innerHeight - 30; // 主表高度,

      return {
          tableHeight: curheight, // 主表高度,
          nodeid:'',
          dataNode:[],
          dataSet:[],
          loading: false,
          selectData: [],
          dataTree: [], //根节点的树
          userData:null,
          defaultEexpandedkeys: [],
          curNode: null,
          defaultProps: {
              children: "children",
              label: "node_name",
              node_id: "node_id",
          },
      }
    },
    beforeDestroy(){
        if (this.sortable1) {
            this.sortable1.destroy();
        }
    },
    mounted: function () {
        let that = this
        that.userData = JSON.parse(sessionStorage.getItem('userData'));
        that.$limits.dragControllerDiv();
        //that.getNode();
        that.rowDrop();
        that.getRootNode();
    },
    methods: {
        help(){
            this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[12695]"),this.$t("getapi[79]"));
        },
        authority(){
            let that = this
            if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                that.$refs.SetBtn.SetOneBtnEnable('help',true);
            }
            that.$refs.SetBtn.SetButtonEnable('save,refresh');
        },
        leftt(e) {
            var left = document.getElementsByClassName("left");
            var mid = document.getElementsByClassName("mid");
            var Box = document.getElementsByClassName("Boxs");
            let bw = Box[0].clientWidth;
            if (e == 1) {
                left[0].style.width = "0px";
                mid[0].style.width = bw - 10 + "px";
            } else {
                left[0].style.width = bw - 50 + "px";
                mid[0].style.width = "0px";
            }
        },
        tableRowClassName({ row, rowIndex }) {
            row.index = rowIndex;
            return 'drag-btn'
        },
        getNode(){
            let that = this
            that.$http.urlpost('/webdoc/doc/GetDocNodeAppSet', '', function (res) {
                if (res.Success == 1) {
                    that.dataNode = res.DataContent;
                    that.authority();
                }
            });
        },
        getDetail(row,node){
            let that = this
            that.selectData = [];
            let parm = {
                Id: row.node_id,
                fromname: "",
                LangType: that.$processdata.getLang()
            }
            that.loading = true
            that.$http.urlpost('/webdoc/doc/GetDocApprovalSet', parm, function (res) {
                if (res.Success == 1) {
                    that.dataSet = res.DataContent;
                    that.nodeid = row.node_id;
                    that.authority();
                }
                that.loading = false
            });
        },
        // 获取用户弹窗
        showUsers(){
            let that = this;
            that.$refs.user.clearInput(true);
        },
        getUsers(data){
            let that = this
            console.log(data)
            let arr = data.filter(item => {
                return that.dataSet.every(item2 => {
                    return item.loginName != item2.login_code;
                });
            });
            data = arr;
            that.dataDetailLineNo = 1
            for (let i = 0; i < that.dataSet.length; i++) {
                if (that.dataSet[i].sort >= that.dataDetailLineNo) {
                    that.dataDetailLineNo = that.dataSet[i].sort + 1
                }
            }
            for(let i=0;i<data.length;i++){
                that.dataSet = [...that.dataSet,{
                    auditid: "",
                    nodeid: that.nodeid,
                    login_code: data[i].loginName,
                    login_name: data[i].user_name,
                    department: data[i].cdepnm,
                    post: data[i].postname,
                    sort: that.dataDetailLineNo++,
                    remark: ''
                }]
            }
        },
        reflash(){
            let that = this
            that.getInfo()
        },
        getInfo(){
            let that = this
            if(that.nodeid == ''){
                return
            }
            that.selectData = [];
            let parm = {
                Id: that.nodeid,
                fromname: "",
                LangType: that.$processdata.getLang()
            }
            that.loading = true
            that.$http.urlpost('/webdoc/doc/GetDocApprovalSet', parm, function (res) {
                if (res.Success == 1) {
                    that.dataSet = res.DataContent;
                    //that.$refs.xTable1.clearCheckboxRow();
                    that.authority();
                }
                that.loading = false
            });
        },
        save(){
            let that = this
            let parm = that.dataSet
            that.$http.urlpost('/webdoc/doc/SaveDocApprovalSet', parm, function (res) {
                if (res.Success == 1) {
                    that.dataSet = res.DataContent;
                    that.getInfo();
                }
            });
        },
        handleSelectionChange({ records }) {
            let that = this;
            that.selectData = records;
        },
        batchDel(){
            let that = this
            this.$confirm(that.$t('getapi[8573]'), that.$t('getapi[194]'), {//'确定删除数据?'
                confirmButtonText: that.$t('getapi[1146]'),
                cancelButtonText: that.$t('getapi[2054]'),
                type: 'warning'
            })
                .then(() => {
                    if(that.selectData[0].auditid == ''){
                        that.dataSet.splice(that.selectData[0].index, 1)
                    } else {
                        let parm = {
                            Code: that.selectData[0].auditid,
                            LangType: that.$processdata.getLang()
                        }
                        that.$http.urlpost('/webdoc/doc/DelDocApprovalSet', parm, function (res) {
                            if (res.Success == 1) {
                                that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                                that.getInfo();
                            }
                        });
                    }
                })
                .catch(() => {
                    this.$message({
                        type: 'info',
                        message: that.$t('getapi[8574]')
                    });
                });
        },
        rowDrop() {
            let that=this;
            that.$nextTick(() => {
                const xTable = that.$refs.xTable1;
                that.sortable1 = Sortable.create(xTable.$el.querySelector('.body--wrapper>.vxe-table--body tbody'), {
                    handle: '.drag-btn',
                    onEnd: ({ newIndex, oldIndex }) => {
                        const currRow = that.dataSet.splice(oldIndex, 1)[0];
                        that.dataSet.splice(newIndex, 0, currRow);
                        for (let i = 0; i < that.dataSet.length; i++) {
                            that.dataSet[i].sort=i+1;
                        }
                    }
                });
            });
        },
        getRootNode() {
            let that = this;
            let parm = {
                Token: that.mytoken(),
                Accurate: false,
                PageIndex: 1,
                PageSize: 100,
                type:1
            };
            that.$http.urlpost('/webdoc/folder/AppSetFindRoot', parm, function (res) {
                if (res.Success == 1) {
                    that.dataTree = res.DataContent;
                    that.defaultEexpandedkeys.push(res.DataContent[0].node_id);
                    that.curNode = res.DataContent[0];
                    that.authority();
                }
            });
        },
        mytoken() {
            if (!this.userData) {
                return null;
            }
            return this.userData.token;
        },
        loadNode(node, resolve) {
            if (node.level === 0) {
                return resolve([]);
            }
            setTimeout(() => {
                let data = node.data;
                let that = this;
                let parm = {
                    Token: that.mytoken(),
                    Accurate: false,
                    PageIndex: 1,
                    PageSize: 100,
                    father_node_id: data.node_id,
                    Soter: "node_name",
                    type:1,
                };
                that.$http.urlpost("/webdoc/folder/AppSetFindList", parm, function (res) {
                    if (res.Success == 1) {
                        resolve(res.DataContent);
                    }
                });
            }, 300);
        },
    }
  };
</script>

<style scoped lang="less">
  .c-search-table {
    width: 100%;
    height: calc(~"100% - 10px");
    /*这里我用了计算属性*/
  }

  .beauty-Scroll {
    .el-scrollbar {
      height: 100%;
      /*此处一定要设置高度，不然内层的计算属性不生效*/
    }

    .el-scrollbar__wrap {
      width: calc(~"100% + 17px");
      /*将垂直滚动条挤到可视区域之外*/
      height: calc(~"100% + 17px");
      /*将水平滚动条挤到可视区域之外*/
    }
  }

  input {
    width: 100%;
    height: 35px;
    border-radius: 8px;
    border: 1px solid #dcdfe6;
    padding-left: 2px;
    padding-right: 2px;
    min-width: 120px;
  }

  table {
    border-collapse: separate;
    border-spacing: 0px 5px;

    td {
      padding-left: 3px;
    }
  }

  .alignment-left {
    text-align: left;
  }

  .alignment-right {
    text-align: right;
  }

  .el-pagination {
    white-space: inherit;
  }

  .el-divider--horizontal {
    margin: 10px 0;
  }

  /deep/.el-table tbody tr:hover>td {
    background-color: transparent !important;
  }

  /deep/ .myRootNode {
    color: green;
  }

  /deep/ .text-red {

    color: red;
  }

  .custom-tree-node {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    padding-right: 8px;
    font-family: '微软雅黑';
  }

  /deep/ .myCell {
    vertical-align: top;
    width: 120px;
    padding-left: 5px;
  }

  /deep/ .myCellNew {
    vertical-align: top;
    width: 65px;
    padding-left: 5px;
  }

  /deep/ .myCellText {
    width: 80px;
    text-align: right;
  }

  /deep/ .myCellText_View {
    width: 70px;
    text-align: right;
    padding-left: 0px;
  }
  /deep/ .myCellText_btn {
    width: 60px;
    text-align: left;
    padding-left: 0px;
  }

  /deep/ .myVersion {
    color: blue;
    /* background-color: #fff; */
  }

  /deep/ .myLi li {
    display: inline-block;
  }

  /deep/ .rowStyler6 {
    /* 控件BUG,前景色改成红色 */
    /* background-color: #ff0000;
    color: #fff; */
    color: #ff0000;
    font-weight: bold;
  }
</style>